/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Modal,
  Segment,
  Dimmer,
  Loader,
  Header,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import cx from 'classnames';
import InputElement from 'react-input-mask';
import Dropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';
import { trim } from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars-2';
import progress from '../../images/icons/progress_ica.gif';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import './StartPageModal.css';

class StartPageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenStartPage: props.isOpenStartPage,
      isOpenAlertModal: false,
      isLoader: false,
      isIpSaving: false,
      useSMTP: 'on',
      errors: {
        license: '',
        name: '',
      },
      checkMsg: '',
      baseUrlError: false,
      domainError: false,
      nickNameError: false,
      hostError: false,
      passwordError: false,
      portError: false,
      addressError: false,
      updateValue: null,
      isOpenLogoutModal: false,
      loadingMsg: null,
      modalAction: '',
      modalBody: '',
      smallText: '',
    };
    this.intervalId = null;
    this.licenseErrorRef = React.createRef();
    this.companyErrorRef = React.createRef();
    this.baseUrlInputRef = React.createRef();
    this.protocolSelectRef = React.createRef();
    this.baseURLErrorRef = React.createRef();
    this.domainInputRef = React.createRef();
    this.domainErrorRef = React.createRef();
    this.usernameInputRef = React.createRef();
    this.passwordInputRef = React.createRef();
    this.hostInputRef = React.createRef();
    this.hostErrorRef = React.createRef();
    this.portInputRef = React.createRef();
    this.portErrorRef = React.createRef();
    this.fromInputRef = React.createRef();
    this.authenticationSelectRef = React.createRef();
    this.enableStarttlsAutoSelectRef = React.createRef();
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const { isOpenStartPage } = this.props;

    if (prevProps.isOpenStartPage !== isOpenStartPage) {
      this.setState({
        isOpenStartPage,
        isLoader: false,
        errors: {
          license: '',
          name: '',
        },
        checkMsg: '',
        baseUrlError: false,
        domainError: false,
        nickNameError: false,
        hostError: false,
        passwordError: false,
        portError: false,
        addressError: false,
        updateValue: null,
      });
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  handleUseSMTP = (e) => {
    const { useSMTP: currentUseSMTP } = this.state;
    const { value } = e.target;
    if (value === currentUseSMTP) {
      return;
    }

    this.setState({
      useSMTP: value,
      baseUrlError: false,
      nickNameError: false,
      passwordError: false,
      addressError: false,
      domainError: false,
      hostError: false,
      portError: false,
    });
  };

  handleChange = (event) => {
    const { state } = this.props;
    const value = event.target.value
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .toUpperCase();
    state.company.setLicenseKey(value);
    state.company.setIsFileUploaded(false);
    this.setErrorMsg('license');
  };

  handleNameChange = (event) => {
    const { state } = this.props;
    state.company.setName(event.target.value);
    this.setErrorMsg('name');
  };

  handleDomainChange = (event) => {
    const { state } = this.props;
    state.company.setDomain(event.target.value);
    this.setState({
      domainError: false,
    });
  };

  handleNickNameChange = (event) => {
    const { state } = this.props;
    state.company.setNickName(event.target.value);
    this.setState({
      nickNameError: false,
    });
  };

  handleHostChange = (event) => {
    const { state } = this.props;
    state.company.setHost(event.target.value);
    this.setState({
      hostError: false,
    });
  };

  handlePWChange = (event) => {
    const { state } = this.props;
    state.company.setPassword(event.target.value);
    this.setState({
      passwordError: false,
    });
  };

  handlePortChange = (event) => {
    const { state } = this.props;
    state.company.setPort(event.target.value);
    this.setState({
      portError: false,
    });
  };

  handleAddressChange = (event) => {
    const { state } = this.props;
    state.company.setAddress(event.target.value);
    this.setState({
      addressError: false,
    });
  };

  handleAuthenticationChange = (event) => {
    const { state } = this.props;
    const selectedValue = event.target.value;
    state.company.setAuthentication(selectedValue);

    if (this.usernameInputRef.current && this.passwordInputRef.current) {
      this.usernameInputRef.current.disabled = selectedValue === 'none';
      this.passwordInputRef.current.disabled = selectedValue === 'none';
    }
  };

  handleEnableStarttlsAutoChange = (event) => {
    const { state } = this.props;
    state.company.setEnableStarttlsAuto(event.target.value);
  };

  handleDrop = (files) => {
    const { t, state } = this.props;
    try {
      const data = new FormData();
      data.append('input_license', files[0]);

      api.uploadLicenseKey(data)
        .then((response) => {
          if (response.response) {
            const value = response.response.license_key.replace(/[^a-zA-Z0-9 ]/g, '').toUpperCase();
            state.company.setLicenseKey(value);
            state.company.setIsFileUploaded(true);
            state.company.setLicenseInfo(response.response);
          }
        })
        .catch((err) => {
          console.error(err);
          const o = err.data?.response;
          if (o?.error_description) {
            if (Array.isArray(o.error_description)) {
              this.setErrorMsg('license', o.error_description[0]);
            } else {
              this.setErrorMsg('license', o.error_description);
            }
          } else {
            this.setErrorMsg('license', t('modal.error.invalid_license'));
          }
        });
    } catch (e) {
      console.error(e);
      this.setErrorMsg('license', t('modal.error.invalid_license'));
    }
  };

  onSubmit = async () => {
    const { state } = this.props;
    const {
      name,
      licenseKey,
      isFileUploaded,
      licenseInfo,
    } = state.company;

    if (!this.validationDefaultInfo()) {
      return;
    }

    if (!this.validationOptionalInfo()) {
      return;
    }

    const licenseData = {
      name,
      license_key: licenseKey,
    };

    const licenseInfoCopy = { ...licenseInfo };
    delete licenseInfoCopy.name;

    if (isFileUploaded) {
      licenseData.apply_method = 'upload';
      Object.assign(licenseData, licenseInfoCopy);
    } else {
      licenseData.apply_method = 'string';
    }

    this.setState({
      isLoader: true,
    });

    await this.updateCompanyData(licenseData);
  };

  setErrorMsg = (field, message = '') => {
    this.setState((prevState) => {
      return {
        errors: {
          ...prevState.errors,
          [field]: message,
        },
      };
    });
  };

  setServerAddress = () => {
    const { t } = this.props;
    this.setState({
      isIpSaving: true,
      baseUrlError: false,
    });

    const baseUrlValue = this.baseUrlInputRef.current?.value.trim();
    const protocolValue = this.protocolSelectRef.current?.value;

    if (!baseUrlValue) {
      this.setState({
        checkMsg: t('modal.error.ip_address_required'),
        isIpSaving: false,
        baseUrlError: true,
      });
      return false;
    }

    const data = {
      address: protocolValue.concat(baseUrlValue),
    };

    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    api
      .serverAddress(data)
      .then(() => {
        this.intervalId = setInterval(() => {
          api
            .getServerAddress()
            .then((res) => {
              if (res.response.ip === 'changing') {
                this.setState({
                  checkMsg: t('modal.error.progress'),
                  isIpSaving: false,
                  baseUrlError: true,
                });
              } else if (res.response.ip !== data.address) {
                this.setState({
                  checkMsg: t('modal.error.failed'),
                  isIpSaving: false,
                  baseUrlError: true,
                });
                if (this.intervalId) {
                  clearInterval(this.intervalId);
                  this.intervalId = null;
                }
              } else if (res.response.ip === data.address) {
                this.setState({
                  checkMsg: t('modal.error.verified'),
                  isIpSaving: false,
                  baseUrlError: true,
                });
                if (this.intervalId) {
                  clearInterval(this.intervalId);
                  this.intervalId = null;
                }
              }
            });
        }, 500);
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          checkMsg: 'connected failed',
          isIpSaving: false,
          baseUrlError: true,
        });
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      });
  };

  getByteLength = (text) => {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += (text.charCodeAt(i) > 128) ? 2 : 1;
    return l;
  };

  /*
  convertToString(value) {
    let text;
    switch (true) {
    case value === 'Already used key by different company. Press Create Company again':
      text = 'Key already in use by different company. Please press Create Company again.';
      break;
    case value === 'Start date is bigger than expiration date':
      text = 'Please check start date and expiration date.';
      break;
    case value === 'Not supported license version. Please contact Insignary':
      text = 'License version not supported. Please contact Insignary at sales@insignary.com';
      break;
    case value === 'Can not find license key!':
      text = 'Cannot find license key!';
      break;
    case value === 'Aleady registered license key!':
      text = 'Already registered license key!';
      break;
    case value === 'Please use online key. This key is download file key':
      text = 'License key is not valid for this service platform. Please contact Insignary at sales@insignary.com';
      break;
    case value === 'License register error! Please contact Insignary':
      text = 'License registration error. Please contact Insignary at sales@insignary.com';
      break;
    case value === 'Not registered license key!':
      text = 'License key not registered!';
      break;
    default:
      text = value;
      break;
    }
    return text;
  }
  */

  updateSmtp = async (value) => {
    const { state } = this.props;
    const data = {
      use_smtp: value,
    };

    try {
      const response = await api.useSmtp(data);
      const res = response.response;
      if (!res.use_smtp) {
        state.company.setNickName('');
        state.company.setPassword('');
        state.company.setAddress('');
        state.company.setDomain('');
        state.company.setHost('');
        state.company.setPort('');
        this.setState({
          baseUrlError: false,
          nickNameError: false,
          passwordError: false,
          addressError: false,
          domainError: false,
          hostError: false,
          portError: false,
        });
      }

    } catch (err) {
      this.setState({
        isLoader: false,
      });
      console.log(err);
    }
  };

  updateCompanyData = async (licenseData) => {
    const { t, state } = this.props;
    this.setState({ loadingMsg: t('modal.message.loading_license_data') });

    try {
      const response = await api.updateCompanySettings(licenseData);
      state.company.saveCompanyData(response.response);
      this.setState({
        errors: {
          license: '',
          name: '',
        },
        loadingMsg: null,
      });
      await this.createEmailData();
    } catch (err) {
      console.error(err);
      this.setState({
        isLoader: false,
      });
      const o = err.data?.response;
      if (o?.error_description) {
        if (Array.isArray(o.error_description)) {
          this.setErrorMsg('license', o.error_description[0]);
        } else {
          this.setErrorMsg('license', o.error_description);
        }
      } else {
        this.setErrorMsg('license', t('modal.error.invalid_license'));
      }
      this.licenseErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }
  };

  updateResult = () => {
    const { t } = this.props;
    this.setState({
      isLoader: false,
      isOpenAlertModal: true,
      updateValue: true,
      loadingMsg: null,
      modalAction: t('modal.title.notice'),
      modalBody: t('modal.message.completed_scan'),
    }, () => {
      this.updateRequiredSettings();
    });
  };

  updateRequiredSettings = () => {
    let required_setting;
    const required_setting_string = localStorage.getItem('required_setting');
    if (required_setting_string) {
      required_setting = required_setting_string.split(',');
    } else {
      required_setting = [];
    }

    const filtered_setting = required_setting.filter((setting) => { return setting === 'password'; });
    localStorage.setItem('required_setting', filtered_setting.join(','));
  };

  createEmailData = async () => {
    const { t } = this.props;
    const { useSMTP } = this.state;
    const data = {
      from: this.fromInputRef.current?.value || null,
      domain: this.domainInputRef.current?.value || null,
      address: this.hostInputRef.current?.value || null,
      port: this.portInputRef.current?.value || null,
      authentication: this.authenticationSelectRef.current?.value || null,
      enable_starttls_auto: this.enableStarttlsAutoSelectRef.current?.value || null,
    };

    if (data.authentication !== 'none') {
      data.username = this.usernameInputRef.current?.value || null;
      data.password = this.passwordInputRef.current?.value || null;
    }

    if (useSMTP === 'on') {
      this.setState({ loadingMsg: t('modal.message.loading_email_data') });
      await this.updateSmtp(true);
      try {
        await api.saveMailer(data);
        this.setState({
          baseUrlError: false,
          nickNameError: false,
          passwordError: false,
          addressError: false,
          domainError: false,
          hostError: false,
          portError: false,
        }, () => {
          this.updateResult();
        });
      } catch (err) {
        this.setState({
          isLoader: false,
        });
        console.error(err);
      }
    } else {
      this.setState({ loadingMsg: t('modal.message.loading_smtp_data') });
      this.setState({ isLoader: false }, async () => {
        await this.updateSmtp(false);
        this.updateResult();
      });
    }
  };

  changeBaseUrl = (e) => {
    const { state } = this.props;
    const { checkMsg, baseUrlError } = this.state;
    if (checkMsg !== '' || baseUrlError) {
      this.setState({
        checkMsg: '',
        baseUrlError: false,
      });
    }
    const str = e.target.value.replace(/\/+$/, '');
    state.company.setBaseUrl(str);
  };

  changeProtocol = (e) => {
    const { state } = this.props;
    state.company.setProtocol(e.target.value);
  };

  closeModal = (e) => {
    const { t } = this.props;

    if (e.target.text === 'Check') {
      return;
    }

    if (e.target.classList.length !== 0) {
      const { classList } = e.target;
      const array = [];
      let i = 0;
      for (i; i < classList.length; i++) {
        if (classList[i] === 'dimmer' || classList[i] === 'modals' || classList[i] === 'active') {
          array.push(classList[i]);
        }
      }
      if (array.length !== 0) {
        return;
      }
    }

    this.setState({
      isOpenLogoutModal: true,
      modalAction: t('modal.title.attention'),
      modalBody: t('modal.message.cancel_init_page'),
      smallText: t('modal.message.cancel_init_detail'),
    });
  };

  closeAlertModal = () => {
    const { closeModal } = this.props;
    const { updateValue } = this.state;
    this.setState({
      isOpenAlertModal: false,
    }, () => {
      if (updateValue) {
        closeModal();
      }
    });
  };

  closeLogoutModal = () => {
    this.setState({
      isOpenLogoutModal: false,
    });
  };

  logout = () => {
    const { closeModal } = this.props;
    closeModal('logout');
  };

  validationDefaultInfo = () => {
    const { t, state } = this.props;
    const { checkMsg } = this.state;
    const {
      licenseKey,
      name,
    } = state.company;

    if (licenseKey.length !== 20) {
      this.setErrorMsg('license', t('modal.error.invalid_license'));
      this.licenseErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
      return false;
    }

    if (trim(name).length === 0) {
      this.setErrorMsg('name', t('modal.error.company_required'));
      this.companyErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
      return false;
    }

    if (this.getByteLength(name) > 30) {
      this.setErrorMsg('name', t('modal.error.company_limit'));
      this.companyErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
      return false;
    }

    if (checkMsg !== 'Verified') {
      this.setState({
        isOpenAlertModal: true,
        modalAction: t('modal.title.attention'),
        modalBody: t('modal.error.check_base_url'),
      });
      this.baseURLErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
      return false;
    }
    return true;
  };

  validationOptionalInfo() {
    const {
      useSMTP,
    } = this.state;

    const data = {
      username: this.usernameInputRef.current?.value,
      password: this.passwordInputRef.current?.value,
      from: this.fromInputRef.current?.value,
      domain: this.domainInputRef.current?.value,
      address: this.hostInputRef.current?.value,
      port: this.portInputRef.current?.value,
      authentication: this.authenticationSelectRef.current?.value,
      enable_starttls_auto: this.enableStarttlsAutoSelectRef.current?.value,
    };

    if (useSMTP === 'on') {
      if (data.domain === '') {
        this.setState({
          domainError: true,
        });
        this.domainErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
        return false;
      }

      if (data.authentication !== 'none') {
        if (data.username === '') {
          this.setState({
            nickNameError: true,
          });
          this.domainErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
          return false;
        }
        if (data.password === '') {
          this.setState({
            passwordError: true,
          });
          this.hostErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
          return false;
        }
      }

      if (data.address === '') {
        this.setState({
          hostError: true,
        });
        this.hostErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
        return false;
      }

      if (data.port === '') {
        this.setState({
          portError: true,
        });
        this.portErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
        return false;
      }

      if (data.from === '') {
        this.setState({
          addressError: true,
        });
        this.portErrorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
        return false;
      }
    }
    return true;
  }

  render() {
    const {
      isLoader,
      errors,
      isIpSaving,
      checkMsg,
      baseUrlError,
      useSMTP,
      domainError,
      nickNameError,
      hostError,
      passwordError,
      portError,
      addressError,
      isOpenLogoutModal,
      isOpenStartPage,
      isOpenAlertModal,
      loadingMsg,
      modalAction,
      modalBody,
      smallText,
    } = this.state;

    const { t, state } = this.props;

    const {
      licenseKey,
      name,
      protocol,
      baseUrl,
      domain,
      nickName,
      host,
      password,
      port,
      address,
      authentication,
      enable_starttls_auto,
    } = state.company;

    return (
      <Modal
        open={isOpenStartPage}
        onClose={this.closeModal}
        className="start_page"
      >
        <div className="setting_popup_wrap">
          <div
            className={cx(
              'setting_popup default_popup',
              {
                active: useSMTP === 'on',
              },
            )}
          >
            <div className="setting_popup_header">
              <h2 className="popup_name">{t('modal.title.init_settings')}</h2>
              <div className="setting_popup_inner_header">
                {t('modal.message.fill_out_form_start_clarity')}
              </div>
              <a
                className="popup_close_button"
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <Scrollbars
              style={{
                height: '490px',
                overflow: 'hidden',
                position: 'relative',
              }}
              renderTrackHorizontal={() => {
                return <div />;
              }}
              renderThumbHorizontal={() => {
                return <div />;
              }}
            >
              <Segment>
                <Dimmer active={isLoader} inverted>
                  <Loader inverted>{loadingMsg}</Loader>
                </Dimmer>
                <div className="setting_popup_contnets">
                  <div className="setting_popup_content_wrap">
                    <div className="left_content" style={{ width: '60%' }}>
                      <h3
                        className="content_title"
                        ref={this.licenseErrorRef}
                      >
                        {t('modal.title.new_license_key')}
                        <em style={{ marginLeft: '0' }} className="asterisk" />
                      </h3>
                      <div className="setting_popup_content">
                        <table className="table">
                          <colgroup>
                            <col style={{ width: '60%' }} />
                            <col style={{ width: '40%' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td>
                                <InputElement
                                  onChange={this.handleChange}
                                  maskChar={null}
                                  placeholder="XXXXX-XXXXX-XXXXX-XXXXX"
                                  mask="*****-*****-*****-*****"
                                  value={licenseKey}
                                  alwaysShowMask
                                />
                              </td>
                              <td>
                                <Dropzone
                                  onDrop={this.handleDrop}
                                >
                                  {({ getRootProps, getInputProps }) => {
                                    return (
                                      <div {...getRootProps({ className: 'green_button' })}>
                                        <input {...getInputProps()} />
                                        <p className="green_button">{t('modal.message.upload_license_file')}</p>
                                      </div>
                                    );
                                  }}
                                </Dropzone>
                              </td>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td colSpan="3">
                                <div
                                  className={cx(
                                    'error',
                                    {
                                      show: errors.license,
                                    },
                                  )}
                                >
                                  {errors.license}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="right_content" style={{ width: '40%' }}>
                      <div className="setting_popup_content">
                        <table className="table">
                          <tbody>
                            <tr />
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="setting_popup_content_wrap">
                    <div className="left_content" style={{ width: '60%' }}>
                      <h3
                        className="content_title"
                      >
                        {t('modal.title.company_name')}
                        <em style={{ marginLeft: '0' }} className="asterisk" />
                      </h3>
                      <div className="setting_popup_content">
                        <input
                          type="text"
                          value={name}
                          onChange={this.handleNameChange}
                        />
                        <div
                          className={cx(
                            'error',
                            {
                              show: errors.name,
                            },
                          )}
                          ref={this.companyErrorRef}
                        >
                          {errors.name}
                        </div>
                      </div>
                    </div>
                    <div className="right_content" style={{ width: '40%' }}>
                      <div className="setting_popup_content" />
                    </div>
                  </div>
                  <div className="setting_popup_content_wrap">
                    <h3
                      className="content_title"
                    >
                      {t('modal.title.base_url')}
                      <em style={{ marginLeft: '0' }} className="asterisk" />
                    </h3>
                    <div className="setting_popup_content">
                      <table className="table">
                        <colgroup>
                          <col style={{ width: '92px' }} />
                          <col style={{ width: '356px' }} />
                          <col style={{ width: '72px' }} />
                          <col style={{ width: '' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td>
                              <select
                                ref={this.protocolSelectRef}
                                value={protocol}
                                onChange={this.changeProtocol}
                              >
                                <option>http://</option>
                                <option>https://</option>
                              </select>
                            </td>
                            <td>
                              <input
                                type="text"
                                value={baseUrl}
                                placeholder={t('modal.message.ip_address_placeholder')}
                                ref={this.baseUrlInputRef}
                                onChange={this.changeBaseUrl}
                              />
                              {checkMsg === 'Failed' ? (
                                <div
                                  className={cx('error', {
                                    show: baseUrlError,
                                  })}
                                  ref={this.baseURLErrorRef}
                                >
                                  {checkMsg}
                                </div>
                              ) : (
                                <div
                                  className={cx('verified', {
                                    show: baseUrlError,
                                  })}
                                  ref={this.baseURLErrorRef}
                                >
                                  {checkMsg}
                                </div>
                              )}
                            </td>
                            <td>
                              {isIpSaving ? (
                                <img
                                  src={progress}
                                  role="presentation"
                                  style={{
                                    width: 14,
                                    height: 14,
                                    margin: '5px 0 0 15px',
                                  }}
                                  alt=""
                                />
                              ) : (
                                <a
                                  className="gray_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={this.setServerAddress}
                                  onKeyUp={this.setServerAddress}
                                >
                                  {t('modal.button.check')}
                                </a>
                              )}
                            </td>
                            <td>&nbsp;</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    className={cx(
                      'setting_popup_content_wrap',
                      {
                        active: useSMTP === 'on',
                      },
                    )}
                  >
                    <h3 className="content_title">
                      {t('modal.title.smtp_toggle')}
                      <em style={{ marginLeft: '0' }} className="" />
                    </h3>
                    <div className="setting_popup_content">
                      <table className="table">
                        <colgroup>
                          <col style={{ width: '50%' }} />
                          <col style={{ width: '50%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td>
                              <select
                                value={useSMTP}
                                onChange={this.handleUseSMTP}
                              >
                                <option value="on">{t('modal.button.on')}</option>
                                <option value="off">{t('modal.button.off')}</option>
                              </select>
                            </td>
                            <td>&nbsp;</td>
                          </tr>
                        </tbody>
                      </table>
                      <div
                        className={cx(
                          'optional_content_wrap',
                          {
                            active: useSMTP === 'on',
                          },
                        )}
                      >
                        <div className="inner_content_wrap">
                          <div className="left_content">
                            <h3 className="">{t('modal.title.domain')}</h3>
                            <div className="setting_content">
                              <input
                                type="text"
                                className="setting_input"
                                value={domain}
                                placeholder={`${t('system.list.example')} insignary.com`}
                                ref={this.domainInputRef}
                                onChange={this.handleDomainChange}
                                disabled={useSMTP === 'off'}
                              />
                              <div
                                className={cx('error', { show: domainError })}
                                ref={this.domainErrorRef}
                              >
                                {t('modal.error.domain_required')}
                              </div>
                            </div>
                          </div>
                          <div
                            className={cx('right_content', {
                              disable:
                                authentication === 'none',
                            })}
                          >
                            <h3 className="">{t('modal.title.user_name')}</h3>
                            <div className="setting_content">
                              <input
                                type="text"
                                className="setting_input"
                                value={nickName}
                                placeholder={`${t('system.list.example')} no-reply@insignary.com`}
                                ref={this.usernameInputRef}
                                disabled={
                                  authentication === 'none'
                                }
                                onChange={this.handleNickNameChange}
                              />
                              <div
                                className={cx('error', {
                                  show: nickNameError,
                                })}
                              >
                                {t('modal.error.user_name_required')}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="inner_content_wrap">
                          <div
                            className="left_content"
                          >
                            <h3 className="">{t('modal.title.host')}</h3>
                            <div className="setting_content">
                              <input
                                type="text"
                                className="setting_input"
                                value={host}
                                placeholder={`${t('system.list.example')} smtp.office365.com`}
                                ref={this.hostInputRef}
                                onChange={this.handleHostChange}
                                disabled={useSMTP === 'off'}
                                autoComplete="new-password"
                              />
                              <div
                                className={cx('error', { show: hostError })}
                                ref={this.hostErrorRef}
                              >
                                {t('modal.error.host_is_required')}
                              </div>
                            </div>
                          </div>
                          <div
                            className={cx('right_content', {
                              disable:
                                authentication === 'none',
                            })}
                          >
                            <h3 className="">{t('modal.title.password')}</h3>
                            <div className="setting_content">
                              <input
                                type="password"
                                className="setting_input"
                                value={password}
                                placeholder={t('modal.message.smtp_placeholder')}
                                ref={this.passwordInputRef}
                                onChange={this.handlePWChange}
                                disabled={
                                  authentication === 'none'
                                }
                                autoComplete="new-password"
                              />
                              <div
                                className={cx('error', {
                                  show: passwordError,
                                })}
                              >
                                {t('modal.error.password_required')}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="inner_content_wrap">
                          <div
                            className="left_content"
                          >
                            <h3 className="">{t('modal.title.port')}</h3>
                            <div className="setting_content">
                              <input
                                type="text"
                                value={port}
                                placeholder={`${t('system.list.example')} 587`}
                                ref={this.portInputRef}
                                onChange={this.handlePortChange}
                                disabled={useSMTP === 'off'}
                              />
                              <div
                                className={cx('error', { show: portError })}
                                ref={this.portErrorRef}
                              >
                                {t('modal.error.port_required')}
                              </div>
                            </div>
                          </div>
                          <div
                            className="right_content"
                          >
                            <h3 className="">{t('modal.title.from')}</h3>
                            <div className="setting_content">
                              <input
                                type="text"
                                value={address}
                                placeholder={`${t('system.list.example')} no-reply@insignary.com`}
                                ref={this.fromInputRef}
                                onChange={this.handleAddressChange}
                                disabled={useSMTP === 'off'}
                              />
                              <div className={cx('error', { show: addressError })}>
                                {t('modal.error.from_required')}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="inner_content_wrap">
                          <div
                            className="left_content"
                          >
                            <h3 className="">{t('modal.title.authentication')}</h3>
                            <div className="setting_content">
                              <select
                                disabled={useSMTP === 'off'}
                                ref={this.authenticationSelectRef}
                                value={authentication}
                                onChange={this.handleAuthenticationChange}
                              >
                                <option value="login">{t('modal.title.login')}</option>
                                <option value="plain">{t('modal.title.plain')}</option>
                                <option value="none">{t('modal.title.none')}</option>
                              </select>
                            </div>
                          </div>
                          <div
                            className="right_content"
                          >
                            <h3 className="">{t('modal.title.start_tls')}</h3>
                            <div className="setting_content">
                              <select
                                disabled={useSMTP === 'off'}
                                ref={this.enableStarttlsAutoSelectRef}
                                value={enable_starttls_auto}
                                onChange={this.handleEnableStarttlsAutoChange}
                              >
                                <option value="true">{t('modal.title.true')}</option>
                                <option value="false">{t('modal.title.false')}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Segment>
            </Scrollbars>
            <div className="setting_popup_button_wrap ">
              <a
                className="button cencel_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                {t('modal.button.cancel')}
              </a>
              <a
                className="button save_button"
                style={{ cursor: 'pointer' }}
                onClick={this.onSubmit}
                onKeyUp={this.onSubmit}
              >
                {t('modal.button.save')}
              </a>
            </div>
          </div>
        </div>
        <Modal
          open={isOpenAlertModal}
          onClose={this.closeAlertModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{modalAction}</h2>
                <p className="text">{modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeAlertModal}
                    onKeyUp={this.closeAlertModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenLogoutModal}
          onClose={this.closeLogoutModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{modalAction}</h2>
                <Modal.Description>
                  <Header>
                    {modalBody}
                  </Header>
                  <p>{smallText}</p>
                </Modal.Description>
                <div className="button_wrap">
                  <a
                    className="left_button"
                    onClick={this.closeLogoutModal}
                    onKeyUp={this.closeLogoutModal}
                  >
                    {t('modal.button.no')}
                  </a>
                  <a
                    className="right_button"
                    onClick={this.logout}
                    onKeyUp={this.logout}
                  >
                    {t('modal.button.yes')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}
export default withTranslation()(inject('state')(observer(StartPageModal)));
